/**
 * Mappers converting GraphQL system nodes to the legacy row shape the
 * system selector table expects.
 */

import type { SystemGraphQL } from './useSystemsRelay';

export interface ISystemListRow {
  /** GraphQL global id - drives row selection (customKey="gid") and systemClick */
  gid: string;
  /** Legacy UUID (oldId) - compared against the current system id for row highlight */
  id: string;
  name: string;
  status: string;
  partner_name: string;
}

export function mapRelaySystemsToRows(systems: SystemGraphQL[]): ISystemListRow[] {
  return systems.map((system) => ({
    gid: system.id,
    id: system.oldId ?? '',
    name: system.name ?? '',
    status: system.status ?? 'open',
    partner_name: system.organization?.name ?? '',
  }));
}
